import classNames from 'classnames';
import React from 'react';

import { RichIcon } from '@eika/rich-icon';

import type { IllustrationHeaderProps, ImageHeaderProps, RichIconHeaderProps } from './types';

export const ImageHeader: React.FC<ImageHeaderProps> = ({
    image: { alt, src, className, ...restImg },
    imagePosition,
}) => {
    return (
        <div
            className={classNames(
                'sgw-market-card__head sgw-market-card__head-image',
                imagePosition ? `image-position--${imagePosition}` : undefined,
            )}
        >
            <picture className="sgw-market-card__head-wrapper">
                <img className={classNames('sgw-market-card__image', className)} src={src} alt={alt} {...restImg} />
            </picture>
        </div>
    );
};

export const IllustrationHeader: React.FC<IllustrationHeaderProps> = ({
    image: { alt, src, className, ...restImg },
}) => {
    return (
        <div className="sgw-market-card__head sgw-market-card__head-illustration">
            <picture className="sgw-market-card__head-wrapper">
                <img
                    className={classNames('sgw-market-card__illustration', className)}
                    src={src}
                    alt={alt}
                    {...restImg}
                />
            </picture>
        </div>
    );
};

export const RichIconHeader: React.FC<RichIconHeaderProps> = ({ icon, imagePosition }) => {
    return (
        <div
            className={classNames(
                'sgw-market-card__head sgw-market-card__head-illustration',
                imagePosition ? `image-position--${imagePosition}` : undefined,
            )}
        >
            <div className="sgw-market-card__head-wrapper">
                <RichIcon type={icon} />
            </div>
        </div>
    );
};
